<template>
  <div class="view-250">
    <div class="group-259">
      <div class="rectangle-88"></div>
      <div class="rectangle-90"></div>
      <div class="rectangle-91"></div>
      <div class="rectangle-89"></div>
    </div>
    <div class="text-43 poppins-normal-storm-dust-14px">Продажи</div>
  </div>
</template>

<script>
export default {
  name: "View322",
};
</script>

<style>
.view-250,
.view-258,
.view-259,
.view-251,
.view-252,
.view-253,
.view-254,
.view-255,
.view-256,
.view-257 {
  display: flex;
  gap: 7px;
  width: 95px;
}

.group-259,
.group-259-8,
.group-259-9,
.group-259-1,
.group-259-2,
.group-259-3,
.group-259-4,
.group-259-5,
.group-259-6,
.group-259-7 {
  height: 21px;
  margin-top: 1px;
  position: relative;
  width: 21px;
}

.rectangle-88,
.rectangle-88-8,
.rectangle-88-9,
.rectangle-88-1,
.rectangle-88-2,
.rectangle-88-3,
.rectangle-88-4,
.rectangle-88-5,
.rectangle-88-6,
.rectangle-88-7 {
  border: 1px solid;
  border-color: var(--azure-radiance);
  border-radius: 2px;
  height: 10px;
  left: 0;
  position: absolute;
  top: 0;
  width: 10px;
}

.rectangle-90,
.rectangle-90-8,
.rectangle-90-9,
.rectangle-90-1,
.rectangle-90-2,
.rectangle-90-3,
.rectangle-90-4,
.rectangle-90-5,
.rectangle-90-6,
.rectangle-90-7 {
  border: 1px solid;
  border-color: var(--azure-radiance);
  border-radius: 2px;
  height: 10px;
  left: 0;
  position: absolute;
  top: 11px;
  width: 10px;
}

.rectangle-91,
.rectangle-91-8,
.rectangle-91-9,
.rectangle-91-1,
.rectangle-91-2,
.rectangle-91-3,
.rectangle-91-4,
.rectangle-91-5,
.rectangle-91-6,
.rectangle-91-7 {
  border: 1px solid;
  border-color: var(--azure-radiance);
  border-radius: 2px;
  height: 10px;
  left: 11px;
  position: absolute;
  top: 11px;
  width: 10px;
}

.rectangle-89,
.rectangle-89-8,
.rectangle-89-9,
.rectangle-89-1,
.rectangle-89-2,
.rectangle-89-3,
.rectangle-89-4,
.rectangle-89-5,
.rectangle-89-6,
.rectangle-89-7 {
  border: 1px solid;
  border-color: var(--azure-radiance);
  border-radius: 2px;
  height: 10px;
  left: 11px;
  position: absolute;
  top: 0;
  width: 10px;
}

.text-43,
.text-485,
.text-636,
.text-7-1,
.text-44,
.text-1-9,
.text-1-10,
.text-14-2,
.text-17-2,
.text-19-1 {
  height: 25px;
  letter-spacing: 0.28px;
  line-height: 25.2px;
  white-space: nowrap;
  width: 65px;
}
</style>
